export const append = (buttonElement) => {
  buttonElement
    .append("ellipse")
    // use this to select the "rect", "ellipse" and "image" part of a button
    .classed("dashboard-button", true)
    // use this to select the button without its shadow
    .classed("dashboard-button-main", true)
    // use this to select the "ellipse" part of the button, including its shadow
    .classed("dashboard-button-ellipse", true)
    .style("fill", "white")
    .style("stroke-width", 1)
    .style("stroke", "black")
  computeAttributes(buttonElement)
}

export const computeAttributes = (buttonElement) => {
  const datum = buttonElement.datum()
  buttonElement
    .selectAll(".dashboard-button-ellipse")
    .attr("cx", datum.width / 2)
    .attr("cy", datum.height / 2)
    .attr("rx", datum.width / 2)
    .attr("ry", datum.height / 2)
}
